// check_webp_feature:
//   'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
//   'callback(feature, result)' will be passed back the detection result (in an asynchronous way!)
function checkWebp (feature: 'lossy' | 'lossless' | 'alpha' | 'animation'): Promise<{ feature: string, isWebpSupported: boolean }> {
  return new Promise((resolve) => {
    const kTestImages: any = {
      lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
      lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
      alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
      animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA'
    }
    const img = new Image()
    img.onload = function () {
      const result: boolean = (img.width > 0) && (img.height > 0)
      resolve({ feature, isWebpSupported: result })
    }
    img.onerror = function () {
      resolve({ feature, isWebpSupported: false })
    }
    img.src = 'data:image/webp;base64,' + kTestImages[feature]
  })
}

export { checkWebp }
